import "./Contact.css";
export default function Contact() {
  return (
    <div id="Contact" className="Contact">
      <div className="contactItems">
        <div className="contactSocial">
          <a href="tel:+919004897287">+91 9004897287</a>
          <a className="contactMail" href="mailto:jeettrivedi0602@gmail.com">
            jeettrivedi0602@gmail.com
          </a>
        </div>
        <div className="contactSocial">
          <a href="https://linkedin.com/in/jeettrivedi03" target="blank">
            <img
              align="center"
              src="https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/linked-in-alt.svg"
              alt="jeettrivedi03"
              height="30"
              width="40"
            />
          </a>
          <a href="https://discord.gg/jeet_tr" target="blank">
            <img
              align="center"
              src="https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/discord.svg"
              alt="jeet_tr"
              height="30"
              width="40"
            />
          </a>
          <a href="https://instagram.com/_jeett._" target="blank">
            <img
              align="center"
              src="https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/instagram.svg"
              alt="_jeett._"
              height="30"
              width="40"
            />
          </a>
        </div>
        <div className="contactSocial">
          <a href="https://www.codechef.com/users/jeet64" target="blank">
            <img
              align="center"
              src="https://cdn.jsdelivr.net/npm/simple-icons@3.1.0/icons/codechef.svg"
              alt="jeet64"
              height="30"
              width="40"
            />
          </a>
          <a href="https://codeforces.com/profile/biffsoprano" target="blank">
            <img
              align="center"
              src="https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/codeforces.svg"
              alt="biffsoprano"
              height="30"
              width="40"
            />
          </a>
          <a href="https://www.leetcode.com/jeet59" target="blank">
            <img
              align="center"
              src="https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/leet-code.svg"
              alt="jeet59"
              height="30"
              width="40"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
